<template>
  <div
    class="news"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="news">News List</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">News Details</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="socialDetail">
      <div class="section wow animate__fadeInDown animate__animated">
        <div class="title">{{ detail.englishTitle }}</div>
        <div class="time">Release time：{{ detail.createTime }}</div>
        <div class="line"></div>
        <div class="content eng_content" v-html="detail.englishContent"></div>
      </div>
    </div>
  </div>
  <div class="news" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="news"> གསར་འགྱུར་རེའུ་མིག </router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color"> གསར་འགྱུར་གྱི་ཞིབ་ཕྲའི་ནང་དོན། </span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="socialDetail">
      <div class="section wow animate__fadeInDown animate__animated">
        <div class="title">{{ detail.zangTitle }}</div>
        <div class="time">ཁྱབ་བསྒྲགས་དུས་ཚོད།：{{ detail.createTime }}</div>
        <div class="line"></div>
        <div class="content" v-html="detail.zangContent"></div>
      </div>
    </div>
  </div>
  <div class="news" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="news">新闻列表</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">新闻详情</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="socialDetail">
      <div class="section wow animate__fadeInDown animate__animated">
        <div class="title">{{ detail.chineseTitle }}</div>
        <div class="time">发布时间：{{ detail.createTime }}</div>
        <div class="line"></div>
        <div class="content" v-html="detail.chineseContent"></div>
      </div>
    </div>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import { noticeDetail } from "../../api/management";
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      language: this.$store.state.language,
      id: this.$route.query.id,
      detail: {},
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {},
  created() {
    this.getNoticeDetail();
  },
  methods: {
    async getNoticeDetail() {
      const res = await noticeDetail(this.id);
      if (res.code == 1) {
        this.detail = res.data;
        if(this.detail.content) {
          this.detail.content = this.detail.content.replace(
            /<img/g,
            "<img style='width:100%;height:auto;'"
          );
        }
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss">
.news {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .exhibitionTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .socialDetail {
    padding-bottom: 50px;
    .section {
      width: 678px;
      .title {
        padding: 30px 0;
        text-align: center;
        font-size: 22px;
        font-weight: 600;
      }
      .time {
        text-align: center;
        margin-bottom: 20px;
        font-size: 16px;
        color: #666;
      }
      .line {
        border-bottom: 1px solid #cccccc;
      }
      .content {
        letter-spacing: 1px;
        margin-top: 20px;
        line-height: 1.5;
        font-size: 18px !important;
        p,
        div {
          // text-indent: 2em;
          margin-bottom: 18px;
          text-align: justify;
          font-size: 18px !important;
          // img {
          //   width: 50% !important;
          //   margin-left: 50%;
          //   transform: translate(-50%);
          // }
        }
      }
      .eng_content {
        div,
        p {
          text-indent: 0;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .news {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.3rem;
    .exhibitionTop {
      position: relative;
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .cloudRight {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .mobilecloudLeft {
      position: absolute;
      bottom: -3.5%;
      right: 0;
      width: 1.25rem;
    }
    .socialDetail {
      padding-bottom: 0.3rem;
      .section {
        width: 100%;
        padding: 0.2rem;
        .title {
          padding: 0.2rem 0;
          font-size: 0.36rem;
        }
        .time {
          text-align: center;
          margin-bottom: 0.2rem;
          font-size: 0.3rem;
        }
        .content {
          font-size: 0.28rem;
          margin-top: 0.2rem;
          line-height: 0.45rem;
        }
      }
    }
  }
}
</style>
